export default function convertUrlsToLinks(text: string) {
	// Regular expression to match HTTP URLs
	var urlRegex = /(https?:\/\/[^\s]+)/g;
	
	// Replace URLs with anchor tags
	var replacedText = text.replace(urlRegex, function (url) {
		return '<a style="color: #0755E4;" href="' + url + '">' + url + '</a>';
	});
	
	return replacedText;
}
